export default __webpack_public_path__ + "static/media/2011-2014.a3d55e34.jpg";